export const BlindingDots = () => {
  return <span className="animate-pulse">...</span>;
};
